import { PrivateQuoteUrlConstant } from 'src/constants';
import { GetPrivateQuotesListResponseDto } from 'src/dtos';
import { httpRequest } from 'src/utils';

export class PrivateQuoteApi {
  async list(authToken: string): Promise<GetPrivateQuotesListResponseDto> {
    const response = await httpRequest<GetPrivateQuotesListResponseDto>({
      method: 'GET',
      url: PrivateQuoteUrlConstant.LIST,
      authToken,
    });

    return response;
  }
}
